// extracted by mini-css-extract-plugin
module.exports = {"main":"TabItem_main__nGziJ","text":"TabItem_text__Sge_y","link":"TabItem_link__ohCS4","search-fade-in":"TabItem_search-fade-in__WNVh2"};